import { Alert, type AlertColor, Snackbar } from '@mui/material';
import React from 'react';

interface OwnProps {
	severity: AlertColor;
	message: string;
	isOpen: boolean;
	onCloseAlert: () => void;
}

const AppSnackbar: React.FC<OwnProps> = (props) => {
	const { message, isOpen, onCloseAlert, severity = 'success' } = props;

	return (
		<Snackbar
			open={isOpen}
			onClose={onCloseAlert}
			sx={{
				'&.MuiSnackbar-root': {
					left: '50%',
					transform: 'translateX(-50%)',
				},
			}}
			autoHideDuration={5000}
		>
			<Alert severity={severity} variant="standard" color={severity}>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default AppSnackbar;
